import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { addProveedorComprador } from "../../../../../../../../../redux/actions/resolucion";
import ProveedoresForm from "./ProveedoresForm";

const initialValues = {
    razonSocial: "",
    cuit: "",
    nombreComercial: "",
}

const ProveedoresFormContainer = ({ formValues, open, handleClose, esComprador }) => {
    const dispatch = useDispatch();
    const [values, setValues] = useState();


    useEffect(() => {
        if (open) {
            if (formValues) setValues(formValues);
            else {
                setValues(initialValues);
            }
        }

    }, [formValues, open])

    const id = values?.index ?? null;

    const handleSubmit = (values) => {
        dispatch(addProveedorComprador({ ...values, esComprador }, id))
        handleClose();
    }

    return (
        <ProveedoresForm
            esComprador={esComprador}
            initialFormValues={formValues}
            open={open}
            handleClose={handleClose}
            handleSubmit={handleSubmit}
            values={values}
            id={id}
        />
    )

}


export default ProveedoresFormContainer;